import Router from './Router';

function App() {
  console.log('Base URL:', process.env.REACT_APP_REST_API_URL);
  return <Router />;
}

export default App;
